/* eslint-disable no-unused-vars */ // Отключаем ESLint для неиспользуемых (но нужных) переменных на уровне файла

import React, { useEffect, useState, useCallback, useRef } from 'react';
// Импортируем стили приложения
// claymorphic-ui.css уже импортируется в index.js, удаляем дублирование

// Импортируем мигрированные стили
import './styles/common.css'; // Общие утилитарные стили
import './styles/components/UserCard.css'; // Стили для карточек пользователей
import './styles/components/Modal.css'; // Стили для модальных окон
import './styles/components/Avatar.css'; // Стили для аватаров
import './styles/components/ProfileEditor.css'; // Стили для редактора профиля
import './styles/components/LoginPage.css'; // Стили для страницы входа
import './styles/components/DesktopMode.css'; // Стили для десктопного режима
import './styles/components/States.css'; // Стили для состояний загрузки и ошибок
import './styles/components/WebApp.css'; // Стили для WebApp и мобильного режима

// eslint-disable-next-line no-unused-vars
import { getApiUrl } from './config'; // Отключаем для getApiUrl, т.к. ESLint ошибается
// import Navigation from './components/Navigation'; // Убираем старую навигацию
import TopNavigation from './components/TopNavigation'; // Импортируем новую
import Navigation from './components/Navigation'; // Импортируем нижнюю навигацию
import UserChain from './components/UserChain';
import ProfileEditor from './components/ProfileEditor';
import InviteGenerator from './components/InviteGenerator';
// import InviteRegistration from './components/InviteRegistration';
// import TagsManager from './components/TagsManager'; // Убираем, он теперь внутри TagsPage
import TagsPage from './components/TagsPage'; // Импортируем новую страницу тегов
import UserProfile from './components/UserProfile';
import InvitePathModal from './components/InvitePathModal'; // Импортируем компонент модального окна пути приглашений
import NotificationsList from './components/NotificationsList'; // Импортируем компонент списка уведомлений
import LoginPage from './components/LoginPage'; // Импортируем новый компонент страницы входа
import SendMessageModal from './components/SendMessageModal'; // Импортируем компонент модального окна отправки сообщения
// Импортируем новые компоненты для Активностей
import ActivityBoard from './components/ActivityBoard';
import CreateActivityForm from './components/CreateActivityForm';
import HomePage from './components/HomePage'; // Импортируем новый компонент для домашней страницы
import DependencyGraphPage from './components/DependencyGraphPage'; // Импортируем компонент страницы графа зависимостей
import DesktopSidebar from './components/DesktopSidebar'; // <-- ИМПОРТИРУЕМ НОВЫЙ КОМПОНЕНТ
import IntroSlider from './components/IntroSlider'; // <-- ИМПОРТИРУЕМ КОМПОНЕНТ СЛАЙДЕРА
import AboutPage from './components/AboutPage'; // <-- ИМПОРТИРУЕМ КОМПОНЕНТ СТРАНИЦЫ О ПРИЛОЖЕНИИ

// --- Вспомогательные компоненты для состояний с обновленными стилями ---
const LoadingState = ({ debugInfo }) => {
  const [showLoading, setShowLoading] = useState(true);

  useEffect(() => {
    // Устанавливаем таймер для показа экрана загрузки минимум на 2 секунды
    const timer = setTimeout(() => {
      setShowLoading(false);
    }, 2000);

    // Очищаем таймер при размонтировании компонента
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {showLoading ? (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url('/Load_screen/load_screen.jpg')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            width: '100vw',
            height: '100vh',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
          }}
        >
          {/* Закомментировано отображение отладочной информации
          {debugInfo && (
            <pre style={{ 
              whiteSpace: 'pre-wrap', 
              fontSize: '10px', 
              textAlign: 'left', 
              background: 'rgba(240,240,240,0.7)', 
              padding: '5px', 
              maxHeight: '100px', 
              overflowY: 'auto',
              margin: '10px'
            }}>
              {debugInfo}
            </pre>
          )}
          */}
        </div>
      ) : (
        <>
          <h1>VINCLE</h1>
          <p>Загрузка данных...</p>
          {/* Закомментировано отображение отладочной информации
          {debugInfo && <pre style={{ whiteSpace: 'pre-wrap', fontSize: '10px', textAlign: 'left', background:'#f0f0f0', padding:'5px', maxHeight:'300px', overflowY:'auto' }}>{debugInfo}</pre>}
          */}
        </>
      )}
    </>
  );
};

const ErrorState = ({ error, debugInfo }) => (
  <>
    <h1>VINCLE</h1>
    <div style={{ color: 'red', background: '#ffebee', padding: '10px', margin: '10px 0' }}>Ошибка: {error}</div>
    {/* Закомментировано отображение отладочной информации
    {debugInfo && <pre style={{ whiteSpace: 'pre-wrap', fontSize: '10px', textAlign: 'left', background:'#f0f0f0', padding:'5px', maxHeight:'300px', overflowY:'auto' }}>{debugInfo}</pre>}
    */}
  </>
);

//const InviteRegistrationState = ({ telegramId, inviteCode, handleRegistrationComplete, debugInfo }) => (
//  <>
//    <h1>VINCLE</h1>
 //   <p>Добро пожаловать! Примите приглашение, чтобы войти.</p>
 //   <InviteRegistration
 //     telegramId={telegramId}
 //     inviteCode={inviteCode}
 //     onRegistrationComplete={handleRegistrationComplete}
 //   />
 //   {/* Закомментировано отображение отладочной информации
 //   {debugInfo && <pre style={{ whiteSpace: 'pre-wrap', fontSize: '10px', textAlign: 'left', background:'#f0f0f0', padding:'5px', maxHeight:'300px', overflowY:'auto' }}>{debugInfo}</pre>}
 //   */}
 // </>
//);

const UnexpectedState = ({ debugInfo }) => (
  <>
    <h1>VINCLE</h1>
    <p>Инициализация...</p>
    {/* Закомментировано отображение отладочной информации
    {debugInfo && <pre style={{ whiteSpace: 'pre-wrap', fontSize: '10px', textAlign: 'left', background:'#f0f0f0', padding:'5px', maxHeight:'300px', overflowY:'auto' }}>{debugInfo}</pre>}
    */}
  </>
);
// --- Конец вспомогательных компонентов ---

// --- Добавляем компонент для отладки ---
const DebugDisplay = ({ data }) => (
    <pre style={{
        fontSize: '10px',
        backgroundColor: '#f8f8f8',
        padding: '5px',
        marginTop: '5px',
        borderRadius: '3px',
        overflow: 'auto',
        maxHeight: '100px',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-all',
        border: '1px solid #ddd'
    }}>
        {JSON.stringify(data, null, 2)}
    </pre>
);
// --------------------------------------------

function App() {
  console.log("App.js: Версия с поддержкой WebApp и Desktop");

  // --- ОСНОВНЫЕ СОСТОЯНИЯ ---
  const [telegramId, setTelegramId] = useState(null);
  const [userData, setUserData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeSection, setActiveSection] = useState('home');
  const [inviteCode, setInviteCode] = useState(null);
  const [viewedUser, setViewedUser] = useState(null);
  const [debugInfo, setDebugInfo] = useState('');
  
  // --- ДОБАВЛЕНО: Состояния для определения среды ---
  const [isWebApp, setIsWebApp] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  // -----------------------------------------
  
  // --- ДОБАВЛЕНО: Состояния для интро-слайдера ---
  const [showIntroSlider, setShowIntroSlider] = useState(false);
  // -----------------------------------------
  
  // --- ДОБАВЛЕНО: Состояния для фильтров ---
  const [filterCity, setFilterCity] = useState('');
  const [searchScope, setSearchScope] = useState('all'); // Добавляем состояние для области поиска
  const [searchQuery, setSearchQuery] = useState(''); // Добавляем состояние для поискового запроса
  // -----------------------------------------

  // --- ДОБАВЛЕНО: Состояния для отображения пути приглашений ---
  const [invitePathData, setInvitePathData] = useState([]);
  const [showInvitePathModal, setShowInvitePathModal] = useState(false);
  const [isLoadingPath, setIsLoadingPath] = useState(false);
  const [errorPath, setErrorPath] = useState(null);
  // -----------------------------------------
  
  // --- ДОБАВЛЕНО: Состояния для уведомлений ---
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [isLoadingNotifications, setIsLoadingNotifications] = useState(false);
  const [notificationsError, setNotificationsError] = useState(null);
  const contentAreaRef = useRef(null);
  // -----------------------------------------

  // --- ДОБАВЛЕНО: Состояния для отправки сообщений ---
  const [showSendMessageModal, setShowSendMessageModal] = useState(false);
  const [messageRecipient, setMessageRecipient] = useState(null);
  // -----------------------------------

  // --- ДОБАВЛЕНО: Состояние для сообщения по умолчанию ---
  const [defaultMessageText, setDefaultMessageText] = useState('');
  // -----------------------------------

  // --- ДОБАВЛЕНО: Ref для UserChain ---
  const userChainRef = useRef(null);
  // -----------------------------------
  
  // Для отслеживания изменений состояния, которые нужно логировать
  const prevStateRef = useRef({ loading, error, telegramId, userData, inviteCode, activeSection });
  
  // Консольное логирование без вызова setState
  const logToConsole = useCallback((message) => {
    console.log(message);
  }, []);

  // eslint-disable-next-line no-unused-vars
  const addDebugInfo = useCallback((message) => {
    const timestamp = new Date().toISOString().split('T')[1].substring(0, 8);
    // Закомментировано обновление состояния отладки
    // setDebugInfo(prev => `${prev}\n[${timestamp}] ${message}`);
    logToConsole(message);
  }, [logToConsole]); // Пустой массив зависимостей - функция стабильна

  // Функция для получения уведомлений пользователя
  const fetchMyNotifications = useCallback(async () => {
    if (!telegramId) {
      console.log("fetchMyNotifications вызван без telegramId");
      return;
    }

    try {
      setIsLoadingNotifications(true);
      setNotificationsError(null);

      console.log(`Получение уведомлений для пользователя ${telegramId}`);
      
      const formData = new FormData();
      formData.append('telegram_id', telegramId);
      
      const response = await fetch(getApiUrl('/api/get_my_notifications'), {
        method: 'POST',
        body: formData
      });
      
      if (!response.ok) {
        throw new Error(`Ошибка при получении уведомлений: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (data.notifications) {
        console.log(`Получено ${data.notifications.length} уведомлений`);
        setNotifications(data.notifications);
        
        // Подсчет непрочитанных уведомлений
        const unread = data.notifications.filter(n => !n.is_read).length;
        setUnreadCount(unread);
        console.log(`Непрочитанных уведомлений: ${unread}`);
      }
    } catch (err) {
      console.error('Ошибка при загрузке уведомлений:', err);
      setNotificationsError(err.message);
    } finally {
      setIsLoadingNotifications(false);
    }
  }, [telegramId]); // Удалил getApiUrl из зависимостей, так как это импортированная функция

  // Функция для отметки уведомления как прочитанного
  const markNotificationAsRead = useCallback(async (notificationId) => {
    if (!telegramId || !notificationId) {
      console.log("markNotificationAsRead вызван без необходимых данных");
      return;
    }

    try {
      console.log(`Отметка уведомления ${notificationId} как прочитанного`);
      
      const formData = new FormData();
      formData.append('telegram_id', telegramId);
      formData.append('notification_id', notificationId);
      
      const response = await fetch(getApiUrl('/api/mark_notification_read'), {
        method: 'POST',
        body: formData
      });
      
      if (!response.ok) {
        throw new Error(`Ошибка при отметке прочтения: ${response.status}`);
      }
      
      // Обновляем состояние уведомлений локально
      setNotifications(prevNotifications => 
        prevNotifications.map(n => 
          n.id === notificationId 
            ? { ...n, is_read: true } 
            : n
        )
      );
      
      // Уменьшаем счетчик непрочитанных
      setUnreadCount(prevCount => Math.max(0, prevCount - 1));
      
      console.log(`Уведомление ${notificationId} отмечено как прочитанное`);
      
    } catch (err) {
      console.error('Ошибка при отметке уведомления:', err);
      // Можно также добавить всплывающее сообщение об ошибке
    }
  }, [telegramId]); // Оставляем только telegramId в зависимостях

  // --- НОВАЯ ФУНКЦИЯ: Проверка аутентификации через API ---
  const checkAuthSession = useCallback(async () => {
    try {
      addDebugInfo("Проверяем сессию через API...");
      // Получаем текущий telegramId из состояния или localStorage
      const currentTgId = telegramId || localStorage.getItem('telegramId');
      
      // Формируем URL с параметром telegram_id, если он доступен
      let url = getApiUrl('/api/check_auth');
      if (currentTgId) {
        url += `?telegram_id=${currentTgId}`;
        addDebugInfo(`Добавляем telegram_id=${currentTgId} к запросу проверки авторизации`);
      }
      
      const response = await fetch(url, {
        method: 'GET',
        credentials: 'include' // Важно для отправки куки сессии
      });
      
      if (response.ok) {
        const data = await response.json();
        addDebugInfo(`Получен ответ от check_auth: ${JSON.stringify(data)}`);
        
        if (data.isAuthenticated) {
          addDebugInfo(`Сессия активна, пользователь аутентифицирован: ${data.telegramId}`);
          
          // Последовательно устанавливаем состояния
          setTelegramId(data.telegramId);
          addDebugInfo(`Установлен telegramId: ${data.telegramId}`);
          
          setIsAuthenticated(true);
          addDebugInfo(`Установлен isAuthenticated: true`);
          
          // Сохраняем ID в localStorage
          localStorage.setItem('telegramId', data.telegramId);
          addDebugInfo(`Сохранён ID в localStorage: ${data.telegramId}`);
          
          return true;
        } else {
          addDebugInfo("Сессия отсутствует или недействительна");
          setIsAuthenticated(false);
          return false;
        }
      } else {
        addDebugInfo(`Ошибка проверки сессии: ${response.status}`);
        setIsAuthenticated(false);
        return false;
      }
    } catch (error) {
      addDebugInfo(`Ошибка при проверке сессии: ${error.message}`);
      setIsAuthenticated(false);
      return false;
    }
  }, [addDebugInfo, telegramId]);

  // --- НОВАЯ ФУНКЦИЯ: Обработчик успешного входа через Telegram Login ---
  const handleLoginSuccess = useCallback(() => {
    addDebugInfo("Вход через Telegram успешен, перезагружаем страницу...");
    window.location.reload(); // Простой способ - перезагрузить страницу для получения сессии
  }, [addDebugInfo]);
  
  // Функция изменения раздела с проверкой и логированием
  const handleSectionChange = useCallback((sectionId) => {
    console.log(`Переключение раздела на: ${sectionId}`);
    
    // Добавляем проверку на пустое значение
    if (!sectionId) {
      console.error('Попытка переключить на пустой раздел');
      return;
    }
    
    // Устанавливаем активный раздел
    setActiveSection(sectionId);
    if (contentAreaRef.current) {
      // Даем микро-паузу перед скроллом
      setTimeout(() => {
          if (contentAreaRef.current) { // Проверяем еще раз на всякий случай
              contentAreaRef.current.scrollTo(0, 0);
              console.log("Прокрутка КОНТЕНТНОЙ ЗОНЫ в начало");
          }
      }, 0);
    } else {
      // Если вдруг указатель не сработал, пробуем старый метод
      console.warn("Указатель contentAreaRef не найден, пытаемся прокрутить WINDOW");
      setTimeout(() => window.scrollTo(0, 0), 0);
    }
    
    // Дополнительные действия для различных разделов
    if (sectionId === "chain" && userChainRef.current) {
      // Скролл вверх в компоненте UserChain
      userChainRef.current.scrollToTop();
    }
    else if (sectionId === "notifications") {
      // При переходе в уведомления, обновляем их
      fetchMyNotifications();
    }
  }, [fetchMyNotifications, userChainRef]);
  
  // Функция для получения пути приглашений
  const fetchInvitePath = useCallback(async (targetUserId) => {
    if (!telegramId || !targetUserId) {
      addDebugInfo("fetchInvitePath: отсутствует telegramId или targetUserId");
      return;
    }
    
    try {
      setIsLoadingPath(true);
      setErrorPath(null);
      
      const formData = new FormData();
      formData.append('current_user_id', telegramId);
      formData.append('target_user_id', targetUserId);
      
      const response = await fetch(getApiUrl('/api/get_invite_path'), {
        method: 'POST',
        body: formData
      });
      
      if (!response.ok) {
        throw new Error(`Ошибка при получении пути: ${response.status}`);
      }
      
      const data = await response.json();
      
      // Данные получены успешно
      setInvitePathData(data.path || data);
      setShowInvitePathModal(true);
      
    } catch (error) {
      console.error('Ошибка при получении пути приглашений:', error);
      setErrorPath(`Ошибка при получении пути: ${error.message}`);
    } finally {
      setIsLoadingPath(false);
    }
  }, [telegramId, addDebugInfo]);
  
  // Обработчик закрытия модального окна пути
  const handleClosePathModal = useCallback(() => {
    setShowInvitePathModal(false);
  }, []);
  
  // Функция для отображения пути приглашений
  const handleShowInvitePath = useCallback((targetUserId) => {
    console.log('Отображение пути приглашений для:', targetUserId);
    fetchInvitePath(targetUserId);
  }, [fetchInvitePath]);
  
  // useEffect для определения среды и проверки аутентификации
  useEffect(() => {
    addDebugInfo("--- Определение среды запуска и проверка аутентификации ---");
    
    // Флаги для обнаружения результатов
    let foundId = null;
    let source = null;
    let foundCode = null;
    let isWebAppEnvironment = false;
    
    // Функция для проверки Window Telegram WebApp
    const checkTelegramWebApp = () => {
      try {
        addDebugInfo("Проверяем наличие Telegram WebApp...");
        if (window.Telegram && window.Telegram.WebApp) {
          const webApp = window.Telegram.WebApp;
          
          // Проверяем наличие данных пользователя
          if (webApp.initDataUnsafe && webApp.initDataUnsafe.user) {
            foundId = webApp.initDataUnsafe.user.id?.toString();
            source = "Telegram WebApp";
            isWebAppEnvironment = true;
            addDebugInfo(`Telegram WebApp обнаружен, ID: ${foundId}`);
            return true;
          } else {
            addDebugInfo("WebApp объект существует, но данные пользователя отсутствуют");
          }
        } else {
          addDebugInfo("Telegram WebApp не обнаружен");
        }
        return false;
      } catch (e) {
        addDebugInfo(`Ошибка при проверке Telegram WebApp: ${e.message}`);
        return false;
      }
    };
    
    // Функция для проверки URL параметров
    const checkUrlParams = () => {
      try {
        addDebugInfo("Проверяем URL параметры...");
        const urlParams = new URLSearchParams(window.location.search);
        
        // Проверяем параметр ID
        const idParam = urlParams.get('id') || urlParams.get('tgid') || urlParams.get('telegram_id');
        if (idParam) {
          foundId = idParam;
          source = "URL Parameter";
          addDebugInfo(`ID найден в URL: ${foundId}`);
        }
        
        // Проверяем параметр инвайт-кода
        const codeParam = urlParams.get('code') || urlParams.get('invite');
        if (codeParam) {
          foundCode = codeParam;
          addDebugInfo(`Инвайт-код найден в URL: ${foundCode}`);
        }
        
        return !!idParam;
      } catch (e) {
        addDebugInfo(`Ошибка при проверке URL параметров: ${e.message}`);
        return false;
      }
    };
    
    // Основная последовательность проверок
    const determineEnvironment = async () => {
      setIsCheckingAuth(true);
      
      // 1. Сначала проверяем Telegram WebApp
      const isWebAppMode = checkTelegramWebApp();
      setIsWebApp(isWebAppMode);
      
      // Применяем CSS-класс к body в зависимости от среды
      document.body.classList.remove('webapp-mode', 'desktop-mode');
      document.body.classList.add(isWebAppMode ? 'webapp-mode' : 'desktop-mode');
      
      // 2. Если это не WebApp, проверяем сессию
      if (!isWebAppMode) {
        addDebugInfo("Не WebApp, проверяем сессию Django...");
        try {
          const response = await fetch(getApiUrl('/api/check_auth'), {
            credentials: 'include'
          });
          
          if (response.ok) {
            const data = await response.json();
            addDebugInfo(`Получен ответ от check_auth (callback): ${JSON.stringify(data)}`);
            
            if (data.isAuthenticated && data.telegramId) {
              foundId = data.telegramId;
              source = "Django Session";
              addDebugInfo(`ID найден в сессии Django: ${foundId}`);
              
              // Прямо здесь устанавливаем состояние для большей надежности
              setTelegramId(data.telegramId);
              setIsAuthenticated(true);
              localStorage.setItem('telegramId', data.telegramId);
            }
          } else {
            addDebugInfo(`Сессия не найдена, статус: ${response.status}`);
          }
        } catch (e) {
          addDebugInfo(`Ошибка при проверке сессии: ${e.message}`);
        }
      } else {
        // В WebApp автоматически аутентифицируем пользователя на основе данных Telegram
        if (foundId) {
          setIsAuthenticated(true);
          setTelegramId(foundId);
          addDebugInfo(`WebApp режим: автоматическая аутентификация с telegramId=${foundId}`);
        }
        
        // В WebApp также проверяем URL параметры для инвайт-кода
        checkUrlParams();
      }
      
      // Если ID не найден в сессии, проверяем URL параметры
      if (!foundId) {
        addDebugInfo(`ID не найден в сессии, проверяем URL параметры...`);
        checkUrlParams();
      }
      
      // Устанавливаем найденные значения в состояние
      if (foundId) {
        setTelegramId(foundId);
        localStorage.setItem('telegramId', foundId);
        addDebugInfo(`Установлен окончательный telegramId=${foundId}`);
      }
      
      if (foundCode) {
        setInviteCode(foundCode);
      }
      
      // Завершаем проверку аутентификации и выводим итоговое состояние
      setIsCheckingAuth(false);
      const finalTelegramId = telegramId || localStorage.getItem('telegramId');
      addDebugInfo(`Финальное состояние: isWebApp=${isWebAppMode}, telegramId=${finalTelegramId}, isAuthenticated=${isAuthenticated}`);
    };
    
    // Запускаем процесс определения среды
    determineEnvironment().then(() => {
      // Проверяем, установлен ли telegramId после всех проверок
      const finalTelegramId = telegramId || localStorage.getItem('telegramId');
      if (finalTelegramId) {
        addDebugInfo(`После определения среды: установлен telegramId=${finalTelegramId}`);
        
        // Убедимся, что telegramId в состоянии установлен
        if (!telegramId) {
          setTelegramId(finalTelegramId);
          addDebugInfo(`Устанавливаем telegramId из localStorage: ${finalTelegramId}`);
        }
      } else {
        addDebugInfo(`После определения среды: telegramId НЕ установлен`);
      }
    });
    
  }, [addDebugInfo, checkAuthSession]);
  
  // useEffect для загрузки профиля пользователя
  useEffect(() => {
    addDebugInfo(`--- useEffect [Profile Load] Start. Deps: tgId=${telegramId}, invCode=${inviteCode}, hasError=${!!error} ---`);

    // Условие для ЗАПУСКА загрузки: Есть ID, еще нет данных, и нет ошибки
    const shouldFetch = telegramId && !userData && !error;

    if (shouldFetch) {
      addDebugInfo(`--> Condition met: Fetching profile for ${telegramId}`);
      setLoading(true); // Устанавливаем loading в true ПЕРЕД запросом

      const fetchUserProfile = async () => {
        try {
          addDebugInfo(`--> Fetching profile from ${getApiUrl('api/get_user_profile')}`);
          const formData = new FormData();
          formData.append('telegram_id', telegramId);
          
          addDebugInfo(`--> Sending request with telegram_id=${telegramId}`);
          const apiUrl = getApiUrl('api/get_user_profile'); // Должен быть 'api/get_user_profile'
          const response = await fetch(apiUrl, { method: 'POST', body: formData });
          addDebugInfo(`--> Profile fetch response status: ${response.status}`);

          if (response.status === 404) {
            // Пользователь не найден - нужно предложить регистрацию
            addDebugInfo("--> User not found (404), user needs to register");
            setUserData(null);
            setError(null); // Сбрасываем ошибку, т.к. 404 - это ожидаемый случай
          } 
          else if (!response.ok) {
            // Другая ошибка от сервера
            const errorText = await response.text();
            addDebugInfo(`--> Server returned error: ${response.status}, text: ${errorText}`);
            throw new Error(`Ошибка сервера: ${response.status}`);
          }
          else {
            // Успешный ответ - получаем данные пользователя
            const data = await response.json();
            // Логируем полный ответ для отладки
            const fullDataString = JSON.stringify(data);
            addDebugInfo(`--> Profile fetch successful, received full data: ${fullDataString}`);
            
            if (data && data.user) {
              // Проверяем наличие всех необходимых полей и устанавливаем значения по умолчанию, если их нет
              const userData = {
                ...data.user,
                // Добавляем поля по умолчанию, если они отсутствуют
                tags: data.user.tags || [],
                links: data.user.links || [],
                // Больше не проверяем поле is_registered
              };
              
              setUserData(userData);
              addDebugInfo(`--> User data processed and set: ${userData.name || userData.username || 'No name'}, ID: ${userData.telegram_id}`);
              setError(null); // Сбрасываем ошибку, если она была
            } else {
              addDebugInfo(`--> Response has no user data: ${JSON.stringify(data)}`);
              throw new Error('Ответ сервера не содержит данных пользователя');
            }
          }
        } catch (err) {
          addDebugInfo(`--> Profile fetch exception: ${err.message}`);
          setError(`Ошибка загрузки профиля: ${err.message}`);
          setUserData(null);
        } finally {
          // ВАЖНО: Устанавливаем loading в false ЗДЕСЬ, после завершения запроса
          setLoading(false);
          addDebugInfo("--> Profile fetch async function finished. Set loading=false.");
        }
      };
      
      fetchUserProfile();
    } else {
      // Если НЕ должны были запускать fetch, убедимся, что loading выключен
      addDebugInfo(`--> Condition NOT met. Skipping profile fetch. Ensuring loading is false.`);
      // Проверяем, нужно ли вообще менять state
      if (loading) {
        setLoading(false);
        addDebugInfo("--> Set loading=false because fetch was not initiated.");
      }
    }
    
    addDebugInfo("--- useEffect [Profile Load] End ---");
  }, [telegramId, inviteCode, userData, error, addDebugInfo, loading]); // Зависимости для определения необходимости загрузки профиля
  
  // useEffect для обработки хэша URL
  useEffect(() => {
    // Функция для обработки хэша
    const handleHashChange = () => {
      const hash = window.location.hash.replace('#', '');
      if (hash) {
        // Проверяем, соответствует ли хэш какой-то из наших секций
        const validSections = ['home', 'chain', 'profile', 'tags', 'invites', 'view-profile', 'notifications', 'activities'];
        if (validSections.includes(hash)) {
          addDebugInfo(`Установка секции ${hash} из хэша URL`);
          setActiveSection(hash);
        }
      }
    };

    // Обрабатываем хэш при первой загрузке
    handleHashChange();

    // Добавляем обработчик изменения хэша
    window.addEventListener('hashchange', handleHashChange);

    // Убираем обработчик при размонтировании компонента
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [addDebugInfo]); // Зависимость от addDebugInfo
  
  // useEffect для периодического обновления уведомлений
  useEffect(() => {
    // Только если пользователь аутентифицирован и есть данные
    if (telegramId && userData) {
      addDebugInfo("Настройка периодического обновления уведомлений");
      
      // Сразу получаем первоначальные данные
      fetchMyNotifications();
      
      // Настраиваем интервал обновления (каждые 60 секунд)
      const intervalId = setInterval(() => {
        // Обновляем только если мы не в разделе уведомлений
        // (в разделе уведомлений мы обновляем при переходе)
        if (activeSection !== 'notifications') {
          addDebugInfo("Автоматическое обновление уведомлений по таймеру");
          fetchMyNotifications();
        }
      }, 60000); // 60 секунд
      
      // Очистка интервала при размонтировании
      return () => {
        addDebugInfo("Остановка периодического обновления уведомлений");
        clearInterval(intervalId);
      };
    }
  }, [telegramId, userData, activeSection, unreadCount, fetchMyNotifications, addDebugInfo]);
  
  // Обработчики (без изменений)
  const handleProfileUpdated = useCallback((updatedProfile) => { 
    // Обработка обновления профиля
    addDebugInfo(`[App] handleProfileUpdated: Обновление userData`);
    // --- Добавляем детальный лог ---
    addDebugInfo(`   Старый avatar: ${userData?.avatar}`);
    addDebugInfo(`   Новый avatar: ${updatedProfile?.avatar}`);
    addDebugInfo(`   Старые теги: ${userData?.tags?.join(', ')}`);
    addDebugInfo(`   Новые теги: ${updatedProfile?.tags?.join(', ')}`);
    // -------------------------------
    setUserData(updatedProfile);
  }, [addDebugInfo, userData]);

  // Функция определения окружения и аутентификации
  const determineEnvironment = useCallback(async () => {
    setIsCheckingAuth(true);
    
    // Переменные для хранения найденных значений
    let foundId = null;
    let foundCode = null;
    let source = null;
    
    // 1. Сначала проверяем Telegram WebApp
    const isWebAppMode = !!window.Telegram?.WebApp;
    setIsWebApp(isWebAppMode);
    
    // Применяем CSS-класс к body в зависимости от среды
    document.body.classList.remove('webapp-mode', 'desktop-mode');
    document.body.classList.add(isWebAppMode ? 'webapp-mode' : 'desktop-mode');
    
    if (isWebAppMode) {
      try {
        addDebugInfo("Обнаружен Telegram WebApp");
        // Получаем данные из Telegram WebApp
        const tgApp = window.Telegram.WebApp;
        if (tgApp.initDataUnsafe && tgApp.initDataUnsafe.user) {
          foundId = tgApp.initDataUnsafe.user.id;
          source = "Telegram WebApp";
          addDebugInfo(`ID найден в Telegram WebApp: ${foundId}`);
        }
      } catch (e) {
        addDebugInfo(`Ошибка при проверке Telegram WebApp: ${e.message}`);
      }
    }
    
    // 2. Если это не WebApp или ID не найден, проверяем сессию
    if (!foundId) {
      addDebugInfo("Не WebApp или ID не найден, проверяем сессию Django...");
      try {
        const response = await fetch(getApiUrl('/api/check_auth'), {
          credentials: 'include'
        });
        
        if (response.ok) {
          const data = await response.json();
          if (data.isAuthenticated && data.telegramId) {
            foundId = data.telegramId;
            source = "Django Session";
            addDebugInfo(`ID найден в сессии Django: ${foundId}`);
            setIsAuthenticated(true);
          }
        } else {
          addDebugInfo(`Сессия не найдена, статус: ${response.status}`);
        }
      } catch (e) {
        addDebugInfo(`Ошибка при проверке сессии: ${e.message}`);
      }
    }
    
    // 3. Если нет сессии, проверяем URL параметры как запасной вариант
    if (!foundId) {
      addDebugInfo("ID не найден в сессии, проверяем URL параметры...");
      try {
        const urlParams = new URLSearchParams(window.location.search);
        
        // Проверяем параметр ID
        const idParam = urlParams.get('id') || urlParams.get('tgid') || urlParams.get('telegram_id');
        if (idParam) {
          foundId = idParam;
          source = "URL Parameter";
          addDebugInfo(`ID найден в URL: ${foundId}`);
        }
        
        // Проверяем параметр инвайт-кода
        const codeParam = urlParams.get('code') || urlParams.get('invite');
        if (codeParam) {
          foundCode = codeParam;
          addDebugInfo(`Инвайт-код найден в URL: ${foundCode}`);
        }
      } catch (e) {
        addDebugInfo(`Ошибка при проверке URL параметров: ${e.message}`);
      }
    }
    
    // В WebApp автоматически аутентифицируем пользователя на основе данных Telegram
    if (isWebAppMode && foundId) {
      setIsAuthenticated(true);
      addDebugInfo(`WebApp режим: автоматическая аутентификация с telegramId=${foundId}`);
    }
    
    // Устанавливаем найденные значения в состояние
    if (foundId) {
      setTelegramId(foundId);
      localStorage.setItem('telegramId', foundId);
    }
    
    if (foundCode) {
      setInviteCode(foundCode);
    }
    
    // Завершаем проверку аутентификации
    setIsCheckingAuth(false);
    
    addDebugInfo(`Финальное состояние: isWebApp=${isWebAppMode}, telegramId=${foundId}, isAuthenticated=${isAuthenticated}`);
    
    return telegramId || foundId; // Возвращаем текущий установленный ID в любом виде
  }, [addDebugInfo]);

  const handleTagsUpdated = useCallback((updatedTags) => {
    addDebugInfo(`[App] handleTagsUpdated: Обновление userData.tags`);
    addDebugInfo(`   Старые теги: ${userData?.tags?.join(', ')}`);
    addDebugInfo(`   Новые теги: ${updatedTags.join(', ')}`);
    setUserData(prevData => {
        // Проверяем, действительно ли теги изменились, чтобы избежать ненужного ререндера
        if (JSON.stringify(prevData.tags) !== JSON.stringify(updatedTags)) {
            return { ...prevData, tags: updatedTags };
        }
        return prevData; // Если не изменились, возвращаем старый state
    });
  }, [addDebugInfo, userData]);

  // Функция для загрузки профиля пользователя
  const fetchUserProfile = useCallback(async () => {
    try {
      addDebugInfo(`Загружаем профиль пользователя ${telegramId}`);
      const formData = new FormData();
      formData.append('telegram_id', telegramId);
      
      const response = await fetch(getApiUrl('/get_user_profile'), { 
        method: 'POST', 
        body: formData 
      });

      if (response.status === 404) {
        // Пользователь не найден - нужно предложить регистрацию
        addDebugInfo("Пользователь не найден (404), требуется регистрация");
        setUserData(null);
        setError(null);
      } 
      else if (!response.ok) {
        // Другая ошибка от сервера
        const errorText = await response.text();
        addDebugInfo(`Сервер вернул ошибку: ${response.status}, текст: ${errorText}`);
        throw new Error(`Ошибка сервера: ${response.status}`);
      }
      else {
        // Успешный ответ - получаем данные пользователя
        const data = await response.json();
        
        if (data && data.user) {
          // Обработка данных пользователя
          const userData = {
            ...data.user,
            tags: data.user.tags || [],
            links: data.user.links || [],
          };
          
          setUserData(userData);
          addDebugInfo(`Данные пользователя загружены: ${userData.name || userData.username || 'Нет имени'}, ID: ${userData.telegram_id}`);
          setError(null);
        } else {
          addDebugInfo(`Ответ не содержит данных пользователя: ${JSON.stringify(data)}`);
          throw new Error('Ответ сервера не содержит данных пользователя');
        }
      }
    } catch (err) {
      addDebugInfo(`Ошибка загрузки профиля: ${err.message}`);
      setError(`Ошибка загрузки профиля: ${err.message}`);
      setUserData(null);
    } finally {
      setLoading(false);
    }
  }, [telegramId, addDebugInfo]);

  const handleRegistrationComplete = useCallback((registrationData) => { 
    // Обработка завершения регистрации
    setUserData({ // Устанавливаем базовые данные после регистрации
        telegram_id: registrationData.user_id,
        username: registrationData.username || `User_${registrationData.user_id}`,
        name: null, city: null, bio: null, avatar: null, tags: [], links: []
    });
    setInviteCode(null); // Сбрасываем инвайт-код
    setActiveSection('profile'); // Переводим на редактирование профиля после регистрации
    addDebugInfo(`Регистрация завершена: ID=${registrationData.user_id}, перенаправлен на профиль`);
  }, [addDebugInfo]);

  const handleViewUserProfile = useCallback((user) => {
    console.log('Просмотр профиля пользователя:', user);
    setViewedUser(user);
    setActiveSection('user_profile'); // Используем user_profile вместо view-profile
  }, []);

  // Добавляем функцию для закрытия просмотра профиля пользователя
  const handleCloseUserProfile = useCallback(() => {
    console.log('Закрытие профиля пользователя');
    setViewedUser(null);
    setActiveSection('chain'); // Возвращаемся к списку пользователей
  }, []);

  // --- ДОБАВЛЕНО: useEffect для обработки события смены поискового запроса ---
  useEffect(() => {
    const handleSearchQueryChanged = (event) => {
      console.log('Search query changed:', event.detail);
      // Если поисковой запрос отличается от текущего, обновляем его
      if (searchQuery !== event.detail) {
        setSearchQuery(event.detail);
      }
    };
    
    window.addEventListener('search-query-changed', handleSearchQueryChanged);
    
    return () => {
      window.removeEventListener('search-query-changed', handleSearchQueryChanged);
    };
  }, [searchQuery]); // Добавляем searchQuery в зависимости для предотвращения лишних обновлений
  // -----------------------------------------

  // Функция для отображения модального окна отправки сообщения
  const handleSendMessage = useCallback((recipient) => {
    console.log('Открытие модального окна отправки сообщения для:', recipient);
    setMessageRecipient(recipient);
    setShowSendMessageModal(true);
  }, []);

  // Улучшенные сеттеры с логированием
  const setFilterCityWithLogging = useCallback((city) => {
    console.log(`App.js: Устанавливаем фильтр города: "${city || 'не задан'}"`);
    setFilterCity(city);
  }, []);

  // Обработчик для удаления уведомления
  const handleDeleteNotification = useCallback(async (notificationId) => {
    if (!telegramId || !notificationId) {
      console.error('Не указан ID уведомления для удаления');
      return;
    }

    try {
      console.log(`Удаление уведомления с ID ${notificationId}`);
      
      const formData = new FormData();
      formData.append('telegram_id', telegramId);
      formData.append('notification_id', notificationId);
      
      const response = await fetch(getApiUrl('/api/delete_notification'), {
        method: 'POST',
        body: formData
      });
      
      if (!response.ok) {
        throw new Error(`Ошибка удаления уведомления: ${response.status}`);
      }
      
      // Обновляем список уведомлений после удаления
      fetchMyNotifications();
      
    } catch (err) {
      console.error('Ошибка при удалении уведомления:', err);
      // Можно добавить обработку ошибки, например, показать уведомление
    }
  }, [telegramId, fetchMyNotifications]);

  // Обработчик для ответа на уведомление
  const handleReplyToNotification = useCallback((notification) => {
    if (!notification || !notification.sender_telegram_id) {
      console.error('Не указаны данные отправителя для ответа');
      return;
    }

    // Создаем объект получателя для модального окна отправки сообщения
    const recipient = {
      telegram_id: notification.sender_telegram_id,
      name: notification.sender_name || 'Пользователь',
      avatar: notification.sender_avatar
    };
    
    // Открываем модальное окно отправки сообщения
    setMessageRecipient(recipient);
    setShowSendMessageModal(true);
    
  }, []);

  // Добавляем обработчик события отклика на активность
  useEffect(() => {
    const handleRespondToActivity = (event) => {
      const activityData = event.detail;
      
      if (!activityData || !activityData.creator) {
        console.error('Неверные данные активности для отклика');
        return;
      }

      // Формируем данные получателя
      const recipient = {
        telegram_id: activityData.creator.telegram_id,
        name: activityData.creator.name || activityData.creator.username || 'Автор активности',
        avatar: activityData.creator.avatar
      };
      
      // Устанавливаем получателя сообщения
      setMessageRecipient(recipient);
      
      // Формируем текст сообщения по умолчанию
      setDefaultMessageText(`Отклик на активность "${activityData.title}"`);
      
      // Открываем модальное окно
      setShowSendMessageModal(true);
    };

    // Подписываемся на событие
    window.addEventListener('respond-to-activity', handleRespondToActivity);
    
    // Очищаем обработчик при размонтировании
    return () => {
      window.removeEventListener('respond-to-activity', handleRespondToActivity);
    };
  }, []);

  // Функция для проверки, нужно ли показывать интро-слайдер
  const checkIntroStatus = useCallback(() => {
    // Проверяем, просматривал ли пользователь уже слайдер
    const introCompleted = localStorage.getItem('introCompleted');
    
    // Временно отключаем проверку - всегда показываем слайдер для отладки
    // if (!introCompleted && isAuthenticated && userData && !loading) {
    if (isAuthenticated && userData && !loading) {
      addDebugInfo("Показываем интро-слайдер для отладки");
      setShowIntroSlider(true);
    } else {
      setShowIntroSlider(false);
      
      // if (introCompleted) {
      //   addDebugInfo("Интро-слайдер уже был просмотрен ранее");
      // }
    }
  }, [isAuthenticated, userData, loading, addDebugInfo]);

  // Обработчик завершения просмотра слайдера
  const handleIntroComplete = useCallback(() => {
    addDebugInfo("Пользователь завершил просмотр интро-слайдера");
    setShowIntroSlider(false);
  }, [addDebugInfo]);

  // Вызываем проверку статуса интро после аутентификации и загрузки данных пользователя
  useEffect(() => {
    if (!isCheckingAuth) { // Проверяем только после завершения проверки аутентификации
      // checkIntroStatus();
    }
  }, [isAuthenticated, userData, loading, isCheckingAuth, checkIntroStatus]);

  // Функция для сброса флага просмотра интро (для отладки)
  const resetIntroStatus = useCallback(() => {
    localStorage.removeItem('introCompleted');
    addDebugInfo("Сброшен флаг просмотра интро для отладки");
    checkIntroStatus(); // Перепроверяем статус интро
  }, [addDebugInfo, checkIntroStatus]);

  // Обновляем функцию renderMainContent для нового дизайна

  const renderMainContent = () => {
    // Добавляем лог в начале функции для отладки состояния
    addDebugInfo(`--- renderMainContent --- isCheckingAuth: ${isCheckingAuth}, isWebApp: ${isWebApp}, isAuthenticated: ${isAuthenticated}, telegramId: ${telegramId}, loading: ${loading}, error: ${!!error}, userData: ${!!userData}, inviteCode: ${inviteCode}, activeSection: ${activeSection}`);

    // 1. Пока идет проверка аутентификации
    if (isCheckingAuth) {
      addDebugInfo("Render: LoadingState (isCheckingAuth)");
      return <LoadingState debugInfo={debugInfo} />;
    }

    // 2. Если Десктоп и не аутентифицирован -> Страница входа
    if (!isWebApp && !isAuthenticated) {
      addDebugInfo("Render: LoginPage (Desktop, not authenticated)");
      return <LoginPage onLoginSuccess={determineEnvironment} debugInfo={debugInfo} />;
    }

    // 3. Если telegramId не определен (маловероятно после проверок, но на всякий случай)
    if (!telegramId) {
      addDebugInfo("Render: ErrorState (telegramId is null/undefined)");
      // В этой ситуации пользователь не сможет работать с приложением
      return <ErrorState error="Не удалось определить ID пользователя. Попробуйте перезапустить приложение из Telegram." debugInfo={debugInfo} />;
    }

    // 4. Пока идет загрузка профиля пользователя
    if (loading) {
      addDebugInfo("Render: LoadingState (loading profile)");
      return <LoadingState debugInfo={debugInfo} />;
    }

    // 5. Если произошла ошибка при загрузке профиля
    if (error) {
      addDebugInfo(`Render: ErrorState (error: ${error})`);
       // НЕ показываем InviteRegistrationState даже при ошибке
      // Можно добавить кнопку для повторной попытки загрузки профиля
      return <ErrorState error={error} debugInfo={debugInfo} />;
    }

    // 6. Если ДАННЫЕ ПОЛЬЗОВАТЕЛЯ УСПЕШНО ЗАГРУЖЕНЫ (userData НЕ null)
    if (userData) {
      addDebugInfo(`Render: Main App Interface (userData exists, activeSection: ${activeSection})`);
      // --- Ключевой момент: Игнорируем inviteCode полностью, т.к. пользователь уже есть ---

      // Показываем интро-слайдер поверх, если нужно
      if (showIntroSlider) {
        return <IntroSlider onComplete={handleIntroComplete} />;
      }

      // Показываем основное содержимое в зависимости от activeSection
      switch(activeSection) {
        case 'home':
          return (
            <>
              <HomePage telegramId={telegramId} onSectionChange={handleSectionChange} />
              {!isWebApp && <div className="bottom-spacer" style={{ height: '80px', width: '100%' }}></div>}
            </>
          );
        case 'chain':
          return (
            <>
              <UserChain telegramId={telegramId} onViewUserProfile={handleViewUserProfile} filterCity={filterCity} searchScope={searchScope} searchQuery={searchQuery} onSectionChange={handleSectionChange} ref={userChainRef} />
              {!isWebApp && <div className="bottom-spacer" style={{ height: '80px', width: '100%' }}></div>}
            </>
          );
        case 'profile':
          return (
            <>
              <ProfileEditor telegramId={telegramId} userData={userData} onProfileUpdated={handleProfileUpdated} onSectionChange={handleSectionChange} />
              {!isWebApp && <div className="bottom-spacer" style={{ height: '80px', width: '100%' }}></div>}
            </>
          );
        case 'invites':
          return (
            <>
              <InviteGenerator telegramId={telegramId} onSectionChange={handleSectionChange} />
              {!isWebApp && <div className="bottom-spacer" style={{ height: '80px', width: '100%' }}></div>}
            </>
          );
        case 'user_profile':
          return viewedUser ? (
            <>
              <UserProfile userData={viewedUser} currentUserId={telegramId} onShowInvitePath={handleShowInvitePath} onSendMessage={handleSendMessage} onClose={handleCloseUserProfile} searchQuery={searchQuery} />
              {!isWebApp && <div className="bottom-spacer" style={{ height: '80px', width: '100%' }}></div>}
            </>
          ) : <div>Информация о пользователе недоступна</div>;
        case 'about':
           return (
             <>
               <AboutPage />
               {!isWebApp && <div className="bottom-spacer" style={{ height: '80px', width: '100%' }}></div>}
             </>
           );
        case 'notifications':
           return (
             <>
               <NotificationsList notifications={notifications} isLoading={isLoadingNotifications} error={notificationsError} onMarkAsRead={markNotificationAsRead} onRefresh={fetchMyNotifications} onShowInvitePath={handleShowInvitePath} onDeleteNotification={handleDeleteNotification} onReplyToNotification={handleReplyToNotification} />
               {!isWebApp && <div className="bottom-spacer" style={{ height: '80px', width: '100%' }}></div>}
             </>
           );
        case 'activities':
           return (
             <>
               <ActivityBoard telegramId={telegramId} onViewUserProfile={handleViewUserProfile} currentUserCity={userData?.city} />
               {!isWebApp && <div className="bottom-spacer" style={{ height: '80px', width: '100%' }}></div>}
             </>
           );
        case 'create_activity':
           return (
             <>
               <CreateActivityForm telegramId={telegramId} onSuccess={() => handleSectionChange('activities')} onCancel={() => handleSectionChange('invites')} />
               {!isWebApp && <div className="bottom-spacer" style={{ height: '80px', width: '100%' }}></div>}
             </>
           );
        case 'dependencyGraph':
           return (
             <>
               <DependencyGraphPage telegramId={telegramId} />
               {!isWebApp && <div className="bottom-spacer" style={{ height: '80px', width: '100%' }}></div>}
             </>
           );
        // --- ДОБАВЛЕН КЕЙС ПО УМОЛЧАНИЮ ---
        default:
             addDebugInfo(`Render: Fallback to HomePage (unknown section: ${activeSection})`);
             return (
               <>
                 <HomePage telegramId={telegramId} onSectionChange={handleSectionChange} />
                 {!isWebApp && <div className="bottom-spacer" style={{ height: '80px', width: '100%' }}></div>}
               </>
             );
      }
    }

    // 7. Если мы дошли сюда: НЕ загрузка, НЕТ ошибки, НО userData == null
    // Это означает, что fetchUserProfile завершился, но не нашел пользователя (вернул 404 или пустой ответ).
    // Поскольку бот ДОЛЖЕН был создать пользователя, это НЕ штатная ситуация.
    // НЕ показываем InviteRegistrationState. Показываем ошибку.
    addDebugInfo("Render: ErrorState (Unexpected: userData is null after loading and no error)");
    // Важно дать понятное сообщение пользователю
    return <ErrorState error="Не удалось загрузить данные вашего профиля. Возможно, произошла ошибка при регистрации. Пожалуйста, попробуйте перезапустить приложение или обратитесь в поддержку." debugInfo={debugInfo} />;
  }; // --- Конец функции renderMainContent ---

  // В конце возвращаем JSX
  return (
    <div className={`app-container ${isWebApp ? 'webapp-mode' : 'desktop-mode'}`}>
      {/* Отображаем интро-слайдер, если нужно */}
      {showIntroSlider && (
        <IntroSlider onComplete={handleIntroComplete} />
      )}
      
      {/* Отображаем модальное окно пути приглашений, если оно открыто */}
      {showInvitePathModal && (
        <InvitePathModal
          invitePathData={invitePathData}
          isLoadingPath={isLoadingPath}
          errorPath={errorPath}
          onClose={() => setShowInvitePathModal(false)}
        />
      )}
      
      {/* Отображаем модальное окно отправки сообщения, если оно открыто */}
      {showSendMessageModal && messageRecipient && (
        <SendMessageModal
          senderId={telegramId}
          recipient={messageRecipient}
          onClose={() => {
            setShowSendMessageModal(false);
            setDefaultMessageText(''); // Сбрасываем дефолтный текст при закрытии
          }}
          defaultMessage={defaultMessageText}
        />
      )}

      {/* Условный рендеринг для десктопа */}
      {!isWebApp ? (
        <div className="desktop-main-container">
          <DesktopSidebar 
            activeSection={activeSection} 
            onSectionChange={handleSectionChange} 
          />
          <div className="desktop-content-area" ref={contentAreaRef}>
            {renderMainContent()} 
            {/* Убираем отступ внизу, если не нужен для десктопа */}
            {/* <div className="bottom-spacer" style={{ height: '80px', width: '100%' }}></div> */} 
          </div>
        </div>
      ) : (
        // --- Мобильная версия (WebApp) --- 
        <div className="webapp-inner-container">
          {/* Рендерим верхнюю навигацию, если мы в мобильном WebApp */}
          <TopNavigation 
            activeSection={activeSection}
            unreadNotifications={unreadCount}
          />
          
          {/* Основной контент в зависимости от текущего раздела */}
          <div className="app-content" ref={contentAreaRef}>
            {renderMainContent()}
             {/* Сервисный блок с отступом внизу ОСТАВЛЯЕМ для мобильной */}
             <div className="bottom-spacer" style={{ height: '80px', width: '100%' }}></div>
          </div>
    
          {/* Нижнее меню навигации для мобильной */}
          <Navigation 
            activeSection={activeSection}
            onSectionChange={handleSectionChange}
          />
        </div>
      )}
    </div>
  );
}

/* eslint-enable no-unused-vars */ // Включаем ESLint обратно

export default App;